import React from 'react';
import TPEAction from 'src/models/common/TPEAction';
import ServiceCollection from 'src/services/ServiceCollection';
import { AllocationGroupState } from 'src/services/tp-allocation/allocation-groups/AllocationGroupsState';
import AllocationGroup, { AllocationGroupFormula } from 'src/models/tp-allocation/AllocationGroup';
import { DatasetRecord } from 'src/models/tp-allocation/DatasetRecord';

/** A Step 2 total as the Step 3 formula editor refers to it. */
export interface DasTotalReference {
    description: string;
    visibleSequence: string;
}

/** Context shared by the Step 3 section and its groups. */
export interface DasAllocationGroupsContextType {
    services: ServiceCollection;
    groupsState: AllocationGroupState;
    groupsDispatch: React.Dispatch<TPEAction>;
    viewMode: string;
    sheetId: string;
    sheetVersion: number;
    /** True while a group or formula is being saved or deleted; the group and formula actions are disabled meanwhile. */
    saving: boolean;
    /** Saved Step 1 rows and Step 2 totals, which formulas may reference. */
    dataSources: DatasetRecord[];
    totals: DasTotalReference[];
    /** Known company codes, offered in the formula mapping editor. */
    companies: string[];
    onDuplicateFormula: (group: AllocationGroup, formula: AllocationGroupFormula) => void;
}

export const DasAllocationGroupsContext = React.createContext(null as unknown as DasAllocationGroupsContextType);
